<template>
  <input-select
    title="Номер договора"
    v-model="contractId"
    v-bind:options="contracts"
    v-on:input="onSelectContractNumber"
  />
</template>
<script>
import InputSelect from '@/components/InputSelect.vue';

const NAME_EVENT_ON_SELECT_CONTRACT_NUMBER = 'on_select_contract_number';
export default {
  name: 'SelectAttachedDocumentContractNumber',
  components: { InputSelect },
  data() {
    return {
      /**
       * @description Номер идентификтора договора, которому принадлежит указанный номер договора.
       * @type {int}
       */
      contractId: null,
    };
  },
  methods: {
    /**
     * Обработать выбор номера договора для Документа. Через событие всплывает ИДЕНТИФИКАТОР
     * договора, которому принадлежит выбранный НОМЕР договора.
     */
    onSelectContractNumber() {
      this.$emit(NAME_EVENT_ON_SELECT_CONTRACT_NUMBER, this.contractId);
    },
  },
  props: {
    /**
     * @description Договора.
     * @type Array<Object>
     */
    contracts: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style scoped lang="scss">
</style>
